module.exports = __webpack_public_path__ + "3fea227bd1c7fd2d9453c1891b3a5b70.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/owl-store-dollars.png
// module id = 2412
// module chunks = 0